import { styled, TextField } from 'opensolar-ui'

const scrollbarThumbStyles = {
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0, 0, 0, 0.15)',
    borderRadius: '2px',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.25)',
    },
  },
}

/** Borderless autosizing multiline field for Ada chat (MUI4 + MUI5 / OSUI class names). */
export const AdaChatTextField = styled(TextField)({
  width: '100%',
  margin: 0,
  '& .MuiOutlinedInput-root, & .OSUI-OutlinedInput-root': {
    minHeight: 'unset',
    padding: '6px 80px 6px 0px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    alignItems: 'flex-start',
    border: 'none',
    '& fieldset, & .OSUI-OutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover fieldset, &:hover .OSUI-OutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused fieldset, &.Mui-focused .OSUI-OutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiOutlinedInput-input, & .OSUI-OutlinedInput-input': {
    padding: 0,
    fontSize: 15,
    lineHeight: 1.4,
    color: '#333333',
    resize: 'none',
    '&::placeholder': {
      color: '#999999',
      opacity: 1,
      fontSize: 15,
    },
    ...scrollbarThumbStyles,
  },
  '& textarea': {
    resize: 'none !important',
    padding: '0 !important',
    ...scrollbarThumbStyles,
  },
})
